function getHeadersEligibility(content) {
  const { heroHeader, header } = content;

  return heroHeader &&
    heroHeader.length > 0 &&
    heroHeader[0]?.content.eligibilityClaim &&
    heroHeader[0]?.content.eligibilityClaim?.trim() !== ''
    ? heroHeader[0].content.eligibilityClaim
    : header && header?.eligibilityClaim && header?.eligibilityClaim?.trim() !== ''
    ? header?.eligibilityClaim
    : '';
}

export const getEligibilityClaim = (productData) => {
  const template = productData?.template?.data?.attributes;

  const mergedClientHeader = getHeadersEligibility({
    heroHeader: productData?.heroHeader,
    header: productData?.header,
  });

  const templateHeader = getHeadersEligibility({
    heroHeader: template?.heroHeader,
    header: template?.header,
  });

  return productData?.eligibilityClaim && productData.eligibilityClaim.trim() !== ''
    ? productData?.eligibilityClaim
    : mergedClientHeader
    ? mergedClientHeader
    : templateHeader;
};
